import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '../../components/ui/button';
import { Menu, X } from 'lucide-react';
import { SlotFleetLogo } from './data';

const NAV_LINKS = [
  { id: 'features', label: 'Features' },
  { id: 'testimonials', label: 'Testimonials' },
  { id: 'pricing', label: 'Pricing' },
  { id: 'faq', label: 'FAQ' },
  { id: 'about', label: 'About' },
  { id: 'blog', label: 'Blog' },
  { id: 'contact', label: 'Contact' },
];

export const NavSection = ({ user, mobileMenuOpen, setMobileMenuOpen, activeSection }) => (
  <nav className="fixed top-0 left-0 right-0 z-50 bg-black/80 backdrop-blur-xl border-b border-amber-500/10">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
      <div className="flex items-center justify-between h-16 md:h-20">
        <a href="#" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }} className="flex items-center gap-3 cursor-pointer" aria-label="SlotFleet - Back to top">
          <SlotFleetLogo className="w-10 h-10" />
          <div className="hidden sm:block">
            <span className="text-xl font-bold text-amber-400">Slot</span>
            <span className="text-xl font-bold text-white">Fleet</span>
          </div>
        </a>

        <div className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map(({ id, label }) => (
            <a
              key={id}
              href={`#${id}`}
              className={`transition-colors text-sm font-medium ${
                activeSection === id
                  ? 'text-amber-400 border-b-2 border-amber-400 pb-0.5'
                  : 'text-gray-400 hover:text-amber-400'
              }`}
            >
              {label}
            </a>
          ))}
        </div>

        <div className="hidden md:flex items-center gap-4">
          {user ? (
            <>
              <Link to="/dashboard">
                <Button className="bg-gradient-to-r from-amber-500 to-yellow-500 hover:from-amber-400 hover:to-yellow-400 text-black font-bold px-6" data-testid="nav-dashboard">
                  Dashboard
                </Button>
              </Link>
              <span className="text-sm text-gray-400">{user.name}</span>
            </>
          ) : (
            <>
              <Link to="/login">
                <Button variant="ghost" className="text-gray-300 hover:bg-white/10 hover:text-amber-400" data-testid="nav-login">
                  Login
                </Button>
              </Link>
              <Link to="/signup">
                <Button className="bg-gradient-to-r from-amber-500 to-yellow-500 hover:from-amber-400 hover:to-yellow-400 text-black font-bold px-6" data-testid="nav-signup">
                  Start Free Trial
                </Button>
              </Link>
            </>
          )}
        </div>

        <button
          className="md:hidden p-2"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          data-testid="mobile-menu-btn"
          aria-label="Toggle mobile menu"
        >
          {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>
    </div>

    {mobileMenuOpen && (
      <motion.div
        initial={{ opacity: 0, height: 0 }}
        animate={{ opacity: 1, height: 'auto' }}
        exit={{ opacity: 0, height: 0 }}
        className="md:hidden bg-neutral-900 border-t border-amber-500/10"
      >
        <div className="px-4 py-6 space-y-4">
          {NAV_LINKS.map(({ id, label }) => (
            <a
              key={id}
              href={`#${id}`}
              className={`block py-2 ${
                activeSection === id ? 'text-amber-400 font-semibold' : 'text-gray-400 hover:text-amber-400'
              }`}
              onClick={() => setMobileMenuOpen(false)}
            >
              {label}
            </a>
          ))}
          <div className="pt-4 space-y-3">
            {user ? (
              <>
                <Link to="/dashboard" className="block">
                  <Button className="w-full bg-gradient-to-r from-amber-500 to-yellow-500 text-black font-bold">
                    Dashboard
                  </Button>
                </Link>
                <p className="text-center text-sm text-gray-400">{user.name}</p>
              </>
            ) : (
              <>
                <Link to="/login" className="block">
                  <Button variant="outline" className="w-full border-amber-500/30 text-amber-400 hover:bg-amber-500/10 hover:text-amber-400">Login</Button>
                </Link>
                <Link to="/signup" className="block">
                  <Button className="w-full bg-gradient-to-r from-amber-500 to-yellow-500 text-black font-bold">
                    Start Free Trial
                  </Button>
                </Link>
              </>
            )}
          </div>
        </div>
      </motion.div>
    )}
  </nav>
);
